module.exports = __webpack_public_path__ + "img/有限数量.5a019272.jpg";